import React, { useCallback, useEffect, useState } from "react";
import { Bell } from "lucide-react";
import ProfileSectionCard from "./ProfileSectionCard";
import {
  enableWebPushNotifications,
  getWebPushStatus,
  watchWebPushStatus,
} from "../../setup/initWebPushNotifications";

const WebPushSettingsPanel = () => {
  const [status, setStatus] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [info, setInfo] = useState("");

  useEffect(() => watchWebPushStatus(setStatus), []);

  const handleEnable = useCallback(async () => {
    setBusy(true);
    setError("");
    setInfo("");
    const result = await enableWebPushNotifications();
    setBusy(false);
    if (!result.ok) {
      setError(result.error || "Could not enable notifications.");
      return;
    }
    setInfo("Notifications enabled. Token registered.");
    setStatus(await getWebPushStatus());
  }, []);

  return (
    <ProfileSectionCard eyebrow="Alerts" title="Push notifications" icon={Bell}>
      <div className="prof-push-status">
        <div className="prof-settings-copy">
          <strong>BetBond alerts</strong>
          <span>{status?.message || "Loading notification status…"}</span>
        </div>
        <span
          className={`prof-push-badge${
            status?.status === "enabled"
              ? " prof-push-badge-on"
              : status?.status === "blocked"
                ? " prof-push-badge-blocked"
                : ""
          }`}
        >
          {status?.label || "…"}
        </span>
      </div>

      {error ? <p className="prof-push-error">{error}</p> : null}
      {info ? <p className="prof-push-hint">{info}</p> : null}

      {status?.status === "disabled" ? (
        <button
          type="button"
          className="prof-push-primary-btn"
          onClick={handleEnable}
          disabled={busy}
        >
          {busy ? "Enabling…" : "Turn on notifications"}
        </button>
      ) : null}

      {status?.status === "blocked" ? (
        <p className="prof-push-hint">
          Re-enable notifications in your browser site settings for this site.
        </p>
      ) : null}

      {status?.status === "unavailable" ? (
        <p className="prof-push-hint">
          Use Chrome, Firefox, or Edge on desktop. Safari has limited support.
        </p>
      ) : null}
    </ProfileSectionCard>
  );
};

export default WebPushSettingsPanel;
